import { render, staticRenderFns } from "./RootProperties.vue?vue&type=template&id=39820df9&scoped=true"
import script from "./RootProperties.vue?vue&type=script&lang=js"
export * from "./RootProperties.vue?vue&type=script&lang=js"
import style0 from "./RootProperties.vue?vue&type=style&index=0&id=39820df9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39820df9",
  null
  
)

export default component.exports